/**
 * Centralized display-label mapping for internal Lead status codes.
 *
 * Rule: DB enum codes are NEVER renamed. Only user-facing labels change here.
 * All React pages must import from this file — no scattered inline mappings.
 *
 * Domain separation:
 *   LEAD_STATUS codes (pipeline stage):
 *     POC_REVIEW          → "Planning Ready"   ← stage reached after managerial review
 *
 *   QUALIFICATION_STATUS codes (scoring output):
 *     POC_REVIEW_REQUIRED → "Manager Review Required"  ← review still pending; not yet Planning Ready
 *
 * Other legacy stored codes:
 *   WAITING_FOR_POC     → "Awaiting Action"
 *   POC_ACTION_REQUIRED → "Action Required"
 */

export const LEAD_STATUS_LABELS = {
  NEW:          "New",
  CONTACTED:    "Contacted",
  QUALIFYING:   "Discovery",          // internal code: QUALIFYING
  QUALIFIED:    "Qualified",
  POC_REVIEW:   "Planning Ready",     // legacy code: POC_REVIEW
  CONVERTED:    "Converted",
  NURTURE:      "Nurture",
  DISQUALIFIED: "Disqualified",
  CLOSED:       "Closed",
};

export const QUALIFICATION_STATUS_LABELS = {
  UNQUALIFIED:         "Unqualified",
  PARTIALLY_QUALIFIED: "Partially Qualified",
  QUALIFIED:           "Qualified",
  POC_REVIEW_REQUIRED: "Manager Review Required", // qualification status: large-event review still required; distinct from POC_REVIEW pipeline stage
};

export const AGENT_STATUS_LABELS = {
  PENDING:              "Pending",
  ACTIVE:               "Active",
  WAITING_FOR_CUSTOMER: "Waiting for Customer",
  ESCALATED:            "Escalated",
  WAITING_FOR_POC:      "Awaiting Action",    // legacy code: WAITING_FOR_POC
  POC_ACTION_REQUIRED:  "Action Required",    // legacy code: POC_ACTION_REQUIRED
  RESOLVED:             "Resolved",
  CLOSED:               "Closed",
  GENERAL:              "General",
};

/** Returns the display label for a code, falling back to the raw code. */
export const leadStatusLabel    = (code) => LEAD_STATUS_LABELS[code]           || code;
export const qualStatusLabel    = (code) => QUALIFICATION_STATUS_LABELS[code]  || code;
export const agentStatusLabel   = (code) => AGENT_STATUS_LABELS[code]          || code;
